// extracted by mini-css-extract-plugin
export default {"sectionContainer":"Section_sectionContainer__QjMBN","section":"Section_section__kylri"};